/**
 * Notification action type
 */
export enum NotificationActionType {
    ACKNOWLEDGE = 'acknowledge',
    NAVIGATE = 'navigate',
}
